const $inject = ['settingsService'];

const lbaGroupCtrl = function (settingsService) {
  const vm = this;
  vm.fields = settingsService.settings.fields;
};

lbaGroupCtrl.$inject = $inject;

export default lbaGroupCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaGroup/lbaGroupCtrl.js